import { useEffect, useState } from 'react';
import { useHistory,useParams } from 'react-router-dom';
import { useForm } from '../forms/useForm';
import { usePagination } from '../pagination/usePagination';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { validarSesion } from '../tokens/useToken';

export const useCreateWSProcess = () => {
      const { idwsconfigProcess } = useParams();
      
    
    const [idwsconfig_a, setidwsconfig_a] = useState(0);
    const [catwsprocess, setcatwsprocess] = useState([]);
    const [id_process_config, setid_process_config] = useState(0);
    const [dataDatacatwsprocessSearch, setDatacatwsprocessSearch] = useState([]);


    const [catwselement, setcatwselement] = useState([]);
    const [id_elements_config, setid_elements_config] = useState(0);
    const [dataDatacatwselementSearch, setDatacatwselementSearch] = useState([]);

  
    const [method, setMethod] = useState("");
    const [modal, setModal] = useState(false);
    const [modalTitle,setModalTitle] = useState("");

    const [loading, setLoading] = useState(false);
    const [createSweet] = useSweetAlert();
    const history = useHistory();
    const [datadeterminations, setdatadeterminations] = useState([]);
    const [dataelements, setdataelements] = useState([]);
    //dilutions
    const [catwsdilutions, setcatwsdilutions] = useState([]);
    const [id_dilutions_colonies, setid_dilutions_colonies] = useState(0);
    const [datacatwsdilutionsSearch, setDatacatwsdilutionsSearch] = useState([]);


    const [formValues, handleInputChange, ,handleUpdateValues, handleSelectValues] = useForm({
        id_exam:0,
        idwsconfig:idwsconfigProcess,
        order_element:0,
        name:"",
        comment_dilutions_colonies:"",
        is_lm:false,
        is_ec:false,
        tubes:0
        });
        
    const [validaciones, setValidaciones] = useState({
        id_exam_valid:0,
        order_element:0,
        name_valid:"",
        comment_dilutions_colonies_valid:"",
        is_lm_valid:false,
        is_ec_valid:false,
    })
    const {id_exam,idwsconfig, order_element, name,comment_dilutions_colonies,is_lm, is_ec,tubes} = formValues;

    const numberItems = 10;
    const { totalPageCount, currentPage, nextPage, previousPage, goToPage } = usePagination(catwsprocess.length, numberItems);

    useEffect(() => {
        let startItems = 0;
        let endItems = numberItems;

        let aux = numberItems * currentPage;

        endItems = aux;

        startItems = endItems - numberItems;
        let listcatwsprocess = [];
        catwsprocess.forEach((data, key) => {

            let posicion = key + 1;
            let visibleTable = false;

            if (posicion > startItems && posicion <= endItems) {
                visibleTable = true;
            }

            listcatwsprocess.push({
                ...data,
                visibleTable: visibleTable
            });
        });

        setcatwsprocess(listcatwsprocess);
    }, [totalPageCount, currentPage])

    const toggle = ()=>{
        setModal(!modal);
    }
   
    useEffect(()=>{
        getWSProcess(idwsconfigProcess);
        getWSDeterminations();
        getWSElements(idwsconfigProcess);
        getWSDilutions(idwsconfigProcess);
    },[history.location]);


    const getWSProcess = async (idwsconfig_a) => {
        let requestOptions = {
            method: 'GET'
        };

        const respuesta = await sendRequest(requestOptions, "WorkSheetSanitary/ListProcessConfig/"+idwsconfig_a);

        if (respuesta.code === 200) {
            let listcatwsprocess= [];
            let startItems = 0;
            let endItems = numberItems;
            let aux = numberItems * currentPage;

            endItems = aux;

            startItems = endItems - numberItems;

            if (respuesta.data.length >= 1) {
                respuesta.data.forEach( (data,index) => {
                    
                let posicion = index + 1;
                let visibleTable = false;
                
                if (posicion > startItems && posicion <= endItems) {
                    visibleTable = true;
                }

                listcatwsprocess.push({
                    id_process_config: data.id_process_config,
                    name: data.name,
                    order_element: data.order_element,
                    id_exam:  data.id_exam,
                    idwsconfig:data.id_wsconfig,
                    name_exam:  data.name_exam,
                    comment_dilutions_colonies:data.comment_dilutions_colonies,
                    is_lm:data.is_lm,
                    is_ec:data.is_ec,
                    tubes: data.cant_tubes
                    });
                });
                setcatwsprocess(listcatwsprocess);
                setDatacatwsprocessSearch(listcatwsprocess);
            }
        }
    }
    const getWSDeterminations = async () => {
        let requestOptions = {
            method: 'GET'
        };

        const respuesta = await sendRequest(requestOptions, "WorkSheetSanitary/ListDeterminationsWSS");

        if (respuesta.code === 200) {
           
            let listDeterminations= [];
            if (respuesta.data.length >= 1) {
                respuesta.data.forEach( (data,index) => {
                    listDeterminations.push({
                        value: data.id_exam,
                        label: data.name,
                    });
                });
                setdatadeterminations(listDeterminations);
            }
           
        }
    }
    const getWSElements = async (idwsconfig_a) => {
        let requestOptions = {
            method: 'GET'
        };

        const respuesta = await sendRequest(requestOptions, "WorkSheetSanitary/ListElementsConfig/"+idwsconfig_a);

        if (respuesta.code === 200) {
            let listcatwselement= [];
            let startItems = 0;
            let endItems = numberItems;
            let aux = numberItems * currentPage;

            endItems = aux;

            startItems = endItems - numberItems;

            if (respuesta.data.length >= 1) {
                respuesta.data.forEach( (data,index) => {
                    
                let posicion = index + 1;
                let visibleTable = false;
                
                if (posicion > startItems && posicion <= endItems) {
                    visibleTable = true;
                }

                listcatwselement.push({
                    id_elements_config: data.id_elements_config,
                    name:  data.name,
                    comment: data.comment,
                    id_process_config: data.id_process_config,
                    id_type_element: data.id_type_element,
                    is_result:data.is_result? 1 : 2,
                    name_process:data.name_process,
                    name_type_element:data.name_type_element,
                    });
                });
                setcatwselement(listcatwselement);
                setDatacatwselementSearch(listcatwselement);
            }
        }
    }
    const getWSDilutions = async (idwsconfig_a) => {
        let requestOptions = {
            method: 'GET'
        };

        const respuesta = await sendRequest(requestOptions, "WorkSheetSanitary/ListColonias/"+idwsconfig_a);

        if (respuesta.code === 200) {
            let listcatwsdilutions= [];
            let startItems = 0;
            let endItems = numberItems;
            let aux = numberItems * currentPage;

            endItems = aux;

            startItems = endItems - numberItems;

            if (respuesta.data.length >= 1) {
                respuesta.data.forEach( (data,index) => {
                    
                let posicion = index + 1;
                let visibleTable = false;
                
                if (posicion > startItems && posicion <= endItems) {
                    visibleTable = true;
                }

                listcatwsdilutions.push({
                    id_dilutions_colonies: data.id_dilutions_colonies,
                    name_dilution:  data.name_dilution,
                    name_process: data.name_process,
                    id_process_config: data.id_process_config,
                    tubes: data.tubes.map(t => t.name).join(", "),
                    });
                });
                setcatwsdilutions(listcatwsdilutions);
                setDatacatwsdilutionsSearch(listcatwsdilutions);
            }
        }
    }
   

    
    const handleCreate = () => {
        handleUpdateValues({
            name:"",
            idwsconfig:idwsconfigProcess,
            id_exam:0,
            order_element:0,
        });

        setValidaciones({
            name_process_valid:false,
        });

        setid_process_config(0);
        setMethod("create");
        setModalTitle("Crear un nuevo proceso");
        toggle();
    }   

    const saveCreate = async (e) => {
        e.preventDefault();

        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }
        let mValues = JSON.stringify(formValues);
        //console.log(mValues,"mValues");

        let requestOptions = {
            method: 'POST',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "WorkSheetSanitary/CreateProcess");
        if (respuesta.code === 200) {
            getWSProcess(idwsconfigProcess);
            getWSDilutions(idwsconfigProcess);
            createSweet("create", "success", "Éxito!", "Creado con éxito");
            setLoading(false);
            toggle();
        }
    }
    const handleUpdate = (id_process_config) => {
        let catwsprocesstemp = catwsprocess.find(s => s.id_process_config === id_process_config);
      
        const updatedValues = {
            id_exam: catwsprocesstemp.id_exam,
            idwsconfig: catwsprocesstemp.idwsconfig,
            order_element: catwsprocesstemp.order_element,
            name: catwsprocesstemp.name,
            comment_dilutions_colonies: catwsprocesstemp.comment_dilutions_colonies,
            is_lm: catwsprocesstemp.is_lm,
            is_ec: catwsprocesstemp.is_ec,
            tubes: catwsprocesstemp.tubes,
        };
    
        //console.log("Valores que se van a actualizar:", updatedValues); // 👈 Aquí lo ves en consola
    
        handleUpdateValues(updatedValues);

        setValidaciones({
            name_ws_valid:false,
            id_type_sample_valid:false,
            list_determinations_valid:false,
        });

        setid_process_config(id_process_config);
        setMethod("update");
        setModalTitle("Modificación de Proceso");
        toggle();
    }

    const saveUpdate = async (e) => {
        e.preventDefault();

        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }

        let body = {
            id_process_config: id_process_config,
            ...{ ...formValues }
        };

        let mValues = JSON.stringify(body);
        
        let requestOptions = {
            method: 'PUT',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "WorkSheetSanitary/UpdateProcess");

        if (respuesta.code === 200) {
            getWSProcess(idwsconfigProcess);
            getWSDilutions(idwsconfigProcess);
            createSweet("create", "info", "Exito!", "Proceso Actualizado");
            setLoading(false);
            toggle();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveUpdate);
        }
    }
    const handleDelete = (id_process_config) => {
        
        let catwsprocesstemp = catwsprocess.find(s => s.id_process_config === id_process_config);

        handleUpdateValues({
            name: catwsprocesstemp.name,
            id_exam:catwsprocesstemp.id_exam,
            idwsconfig:catwsprocesstemp.idwsconfig,
            comment_dilutions_colonies:catwsprocesstemp.comment_dilutions_colonies,
            is_lm:catwsprocesstemp.is_lm,
            is_ec:catwsprocesstemp.is_ec,
            tubes: catwsprocesstemp.tubes,
        });

        setid_process_config(id_process_config);
        setMethod("delete");
        setModalTitle("eliminar");
        toggle();
    }

    const saveDelete = async (e) => {
        e.preventDefault();

        setLoading(true);

        let requestOptions = {
            method: 'DELETE'
        };

        const respuesta = await sendRequest(requestOptions, `WorkSheetSanitary/process/${id_process_config}`);

        if (respuesta.code === 200) {
            getWSProcess(idwsconfigProcess);
            setLoading(false);
            createSweet("create", "info", "Exito!", "Proceso eliminado");
            toggle();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveDelete);
        }
       

    }

    const validarForm = () => {
        let statusValidation = false;
        let newValidations = {};
      //console.log(formValues,"formValues");
        if (formValues.name === "" || formValues.name.length < 3) {
            newValidations = {
                ...newValidations,
                name_valid: true
            };
            statusValidation = true;
        }
        else {
            newValidations = {
                ...newValidations,
                name_valid: false
            }
        }
        if (formValues.id_exam <= 0) {
            newValidations = {
                ...newValidations,
                id_exam_valid: true
            };
            statusValidation = true;
        }
        else {
            newValidations = {
                ...newValidations,
                id_exam_valid: false
            }
        }
       
        
        setValidaciones(newValidations);

        return statusValidation;
    }

    const handleSearchWSS = (e) => {

        let busqueda = e.target.value;
        let newMethod = [];

        dataDatacatwsprocessSearch.forEach(element => {            

            let cadena = element.name.toUpperCase();
            if (cadena.indexOf(busqueda.toUpperCase()) > -1) {
                element.visibleTable = true;
                newMethod.push(element);
            }
        });
        setcatwsprocess(newMethod);
    }
    const navigateNewProcessWS = (idwsconfig) => {
        
            history.push("../sanitaria/creacion_procesos/" + idwsconfig);
        
    }
   
    const handleSelectValuesNew = async (e) => {
        if (e !== null && e?.value !== undefined) {
            handleUpdateValues({
                id_exam: e?.value,  // o e.value si lo deseas
            });
        } else {
            handleUpdateValues({
                id_exam: null,
            });
        }
       // console.log(formValues,"forma");
    };
    //FUNCIONES ELEMENTOS
    const [formValuesElements, handleInputChangeElements, ,handleUpdateValuesElements, handleSelectValuesElements] = useForm({
        nameElement:"",
        commentElement:"",
        id_process_configElement :0,
        id_type_elementElement :0,
        is_result:0
        });
    const [validacionesElements, setValidacionesElements] = useState({
            nameElement_valid:"",
            id_process_configElement_valid:0,
            id_type_elementElement_valid:0,
        })  
  
    const { nameElement,commentElement,id_process_configElement,id_type_elementElement,is_result} = formValuesElements;

    const handleCreateElements = () => {
        handleUpdateValuesElements({
            nameElement:"",
            commentElement:"",
            id_process_configElement :0,
            id_type_elementElement :0,
            is_result:0
        });


        setid_elements_config(0);
        setMethod("createElement");
        setModalTitle("Crear un nuevo elemento");
        toggle();
    }   

    const saveCreateElements = async (e) => {
        e.preventDefault();

        setLoading(true);

        if (validarFormElements()) {
            setLoading(false);
            return;
        }
        let payload = {
                name: formValuesElements.nameElement,
                comment: formValuesElements.commentElement,
                orden: formValuesElements.orden || 0, // agrega orden si lo estás manejando
                id_type_element: formValuesElements.id_type_elementElement,
                id_process_config: formValuesElements.id_process_configElement,
                is_result: formValuesElements.is_result === 1 ? true : false, // si lo estás manejando como 1 o 0
        };
        let mValues = JSON.stringify(payload);
       // console.log(mValues,"mValues");

        let requestOptions = {
            method: 'POST',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "WorkSheetSanitary/CreateElement");
        if (respuesta.code === 200) {
            getWSElements(idwsconfigProcess);
            createSweet("create", "success", "Éxito!", "Creado con éxito");
            setLoading(false);
            toggle();
        }
    }

    const handleUpdateElements = (id_elements_config) => {
        let catwselementstemp = catwselement.find(s => s.id_elements_config === id_elements_config);
       // console.log(catwselementstemp,"catwselementstemp");

        handleUpdateValuesElements({
            nameElement: catwselementstemp.name,
            commentElement:catwselementstemp.comment,
            id_process_configElement:catwselementstemp.id_process_config,
            is_result:catwselementstemp.is_result,
            id_type_elementElement:catwselementstemp.id_type_element,
        });
        setValidacionesElements({
            name_valid: false,
        });
   
        setid_elements_config(id_elements_config);
        setMethod("updateelements");
        setModalTitle("Modificación de Elementos");
        toggle();
    }

    const saveUpdateElements = async (e) => {
        e.preventDefault();

        setLoading(true);

        if (validarFormElements()) {
            setLoading(false);
            return;
        }
        let payload = {
                id_elements_config: id_elements_config,
                name: formValuesElements.nameElement,
                comment: formValuesElements.commentElement,
                orden: formValuesElements.orden || 0, // agrega orden si lo estás manejando
                id_type_element: formValuesElements.id_type_elementElement,
                id_process_config: formValuesElements.id_process_configElement,
                is_result: formValuesElements.is_result === 1 ? true : false, // si lo estás manejando como 1 o 0
        };
        let mValues = JSON.stringify(payload);
        
        let requestOptions = {
            method: 'PUT',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "WorkSheetSanitary/UpdateWSElement");

        if (respuesta.code === 200) {
            getWSElements(idwsconfigProcess);
            createSweet("create", "info", "Exito!", "Elemento Actualizado");
            setLoading(false);
            toggle();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveUpdate);
        }
    }
    const handleDeleteElements = (id_elements_config) => {
        
        let catwselementstemp = catwselement.find(s => s.id_elements_config === id_elements_config);

        handleUpdateValuesElements({
            nameElement: catwselementstemp.name,
            commentElement:catwselementstemp.comment,
            id_process_configElement:catwselementstemp.id_process_config,
            is_result:catwselementstemp.is_result,
            id_type_elementElement:catwselementstemp.id_type_element,
        });

        setid_elements_config(id_elements_config);
        setMethod("deleteelement");
        setModalTitle("eliminar");
        toggle();
    }

    const saveDeleteElements = async (e) => {
        e.preventDefault();

        setLoading(true);

        let requestOptions = {
            method: 'DELETE'
        };

        const respuesta = await sendRequest(requestOptions, `WorkSheetSanitary/element/${id_elements_config}`);

        if (respuesta.code === 200) {
            getWSElements(idwsconfigProcess);
            setLoading(false);
            createSweet("create", "info", "Exito!", "Elemento eliminado");
            toggle();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveDeleteElements);
        }
       

    }

    const validarFormElements = () => {
        let statusValidation = false;
        let newValidations = {};
        if (formValuesElements.nameElement === "" || formValuesElements.nameElement.length < 3) {
            newValidations = {
                ...newValidations,
                nameElement_valid: true
            };
            statusValidation = true;
        }
        else {
            newValidations = {
                ...newValidations,
                nameElement_valid: false
            }
        }
        if (formValuesElements.id_process_configElement <= 0) {
            newValidations = {
                ...newValidations,
                id_process_configElement_valid: true
            };
            statusValidation = true;
        }
        else {
            newValidations = {
                ...newValidations,
                id_process_configElement_valid: false
            }
        }
        
        setValidacionesElements(newValidations);

        return statusValidation;
    }

    const handleSearchWSSElements = (e) => {

        let busqueda = e.target.value;
        let newMethod = [];

        dataDatacatwselementSearch.forEach(element => {            

            let cadena = element.name.toUpperCase();
            if (cadena.indexOf(busqueda.toUpperCase()) > -1) {
                element.visibleTable = true;
                newMethod.push(element);
            }
        });
        setcatwselement(newMethod);
    }
    //FUNCIONES DULUCIONES
    const [formValuesDilutions, handleInputChangeDilutions, ,handleUpdateValuesDilutions, handleSelectValuesDilutions] = useForm({
        name_dilution:  "",
        id_process_config_dilution: 0,
        });
    const [validacionesDilutions, setValidacionesDilutions] = useState({
        name_dilution_valid:"",
        id_process_config_dilution_valid:0,
        })  
  
    const { name_dilution,id_process_config_dilution} = formValuesDilutions;

    const handleCreateDilutions = () => {
        handleUpdateValuesDilutions({
            name_dilution:  "",
            id_process_config_dilution: 0,
        });


        setid_elements_config(0);
        setMethod("createDilution");
        setModalTitle("Crear una nueva Dilución");
        toggle();
    }   

    const saveCreateDilutions = async (e) => {
        e.preventDefault();

        setLoading(true);
console.log("sadasdf");
        if (validarFormDilutions()) {
            setLoading(false);
            return;
        }
        let payload = {
            name_dilution: formValuesDilutions.name_dilution,
            id_process_config: formValuesDilutions.id_process_config_dilution,
        };
        let mValues = JSON.stringify(payload);
       // console.log(mValues,"mValues");

        let requestOptions = {
            method: 'POST',
            body: mValues
        };
       
        const respuesta = await sendRequest(requestOptions, "WorkSheetSanitary/CreateDilutions");
        if (respuesta.code === 200) {
            getWSDilutions(idwsconfigProcess);
            createSweet("create", "success", "Éxito!", "Creado con éxito");
            setLoading(false);
            toggle();
        }
    }

    const handleUpdateDilutions = (id_dilutions_colonies) => {
        let catwsdilutionstemp = catwsdilutions.find(s => s.id_dilutions_colonies === id_dilutions_colonies);
       //console.log(catwsdilutionstemp,"catwsdilutionstemp");

        handleUpdateValuesDilutions({
            name_dilution:  catwsdilutionstemp.name_dilution,
            id_process_config_dilution:  catwsdilutionstemp.id_process_config,
        });
        setValidacionesDilutions({
            name_dilution_valid: false,
            id_process_config_dilution_valid: false,
        });
        setid_dilutions_colonies(id_dilutions_colonies);
        setMethod("updateddilution");
        setModalTitle("Modificación de Diluciones");
        toggle();
    }

    const saveUpdateDilutions= async (e) => {
        e.preventDefault();
       // console.log("mValues");
        setLoading(true);

        if (validarFormDilutions()) {
            setLoading(false);
            return;
        }
        let payload = {
            id_dilutions_colonies:id_dilutions_colonies,
            name_dilution: formValuesDilutions.name_dilution,
            id_process_config: formValuesDilutions.id_process_config_dilution,
        };
        let mValues = JSON.stringify(payload);
      
        let requestOptions = {
            method: 'PUT',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "WorkSheetSanitary/UpdateWSDilution");

        if (respuesta.code === 200) {
            getWSDilutions(idwsconfigProcess);
            createSweet("create", "info", "Exito!", "Elemento Actualizado");
            setLoading(false);
            toggle();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveUpdate);
        }
    }
    const handleDeleteDilutions = (id_dilutions_colonies) => {
        
        let catwsdilutionstemp = catwsdilutions.find(s => s.id_dilutions_colonies === id_dilutions_colonies);
        console.log(id_dilutions_colonies);
        handleUpdateValuesDilutions({
            name_dilution:  catwsdilutionstemp.name_dilution,
            id_process_config_dilution:  catwsdilutionstemp.id_process_config,
        });

        setid_dilutions_colonies(id_dilutions_colonies);
        setMethod("deletedilution");
        setModalTitle("eliminar");
        toggle();
    }

    const saveDeleteDilutions = async (e) => {
        e.preventDefault();

        setLoading(true);

        let requestOptions = {
            method: 'DELETE'
        };

        const respuesta = await sendRequest(requestOptions, `WorkSheetSanitary/dilution/${id_dilutions_colonies}`);

        if (respuesta.code === 200) {
            getWSDilutions(idwsconfigProcess);
            setLoading(false);
            createSweet("create", "info", "Exito!", "Elemento eliminado");
            toggle();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveDeleteDilutions);
        }
       

    }

    const validarFormDilutions = () => {
        let statusValidation = false;
        let newValidations = {};
        if (formValuesDilutions.name_dilution === "" || formValuesDilutions.name_dilution.length < 3) {
            newValidations = {
                ...newValidations,
                name_dilution_valid: true
            };
            statusValidation = true;
        }
        else {
            newValidations = {
                ...newValidations,
                name_dilution_valid: false
            }
        }
        if (formValuesDilutions.id_process_config_dilution <= 0) {
            newValidations = {
                ...newValidations,
                id_process_config_dilution_valid: true
            };
            statusValidation = true;
        }
        else {
            newValidations = {
                ...newValidations,
                id_process_config_dilution_valid: false
            }
        }
        
        setValidacionesDilutions(newValidations);

        return statusValidation;
    }

    const handleSearchWSSDilutions = (e) => {

        let busqueda = e.target.value;
        let newMethod = [];

        dataDatacatwselementSearch.forEach(element => {            

            let cadena = element.name.toUpperCase();
            if (cadena.indexOf(busqueda.toUpperCase()) > -1) {
                element.visibleTable = true;
                newMethod.push(element);
            }
        });
        setcatwsdilutions(newMethod);
    }
    
    
    return {
        idwsconfig_a,catwsprocess,id_process_config,validaciones,
        method, 
        handleInputChange, handleSearchWSS, loading, 
        toggle, modal, modalTitle,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        nextPage, previousPage, goToPage, totalPageCount, currentPage,
        datadeterminations,handleUpdateValues,handleSelectValues,formValues,
        navigateNewProcessWS,dataDatacatwsprocessSearch,handleSelectValuesNew,
        id_exam,idwsconfig, order_element, name,comment_dilutions_colonies,is_lm, is_ec,
       catwselement,id_elements_config, dataDatacatwselementSearch,
        //elementos
        handleSearchWSSElements,handleUpdateElements,saveUpdateElements,handleDeleteElements,
        saveDeleteElements,validarFormElements,handleCreateElements,saveCreateElements,
        formValuesElements, handleInputChangeElements, handleUpdateValuesElements, handleSelectValuesElements,
        validacionesElements,catwsdilutions,
         //diluciones
         handleSearchWSSDilutions,handleUpdateDilutions,saveUpdateDilutions,handleDeleteDilutions,
         saveDeleteDilutions,validarFormDilutions,handleCreateDilutions,saveCreateDilutions,
         formValuesDilutions, handleInputChangeDilutions, handleUpdateValuesDilutions, handleSelectValuesDilutions,
         validacionesDilutions,
    }

}




